import { render } from "./MainProductsWithMinimumStock.vue?vue&type=template&id=5691e404&scoped=true"
import script from "./MainProductsWithMinimumStock.vue?vue&type=script&lang=js"
export * from "./MainProductsWithMinimumStock.vue?vue&type=script&lang=js"

import "./MainProductsWithMinimumStock.vue?vue&type=style&index=0&id=5691e404&scoped=true&lang=css"

import exportComponent from "D:\\Sistema\\Nueva carpeta\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5691e404"]])

export default __exports__